module.exports = __webpack_public_path__ + "static/img/sangdi2.ae64c9d3.jpg";